module.exports = __webpack_public_path__ + "static/media/BasierCircle-Regular.f97784bc.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/fonts/Basier Circle/Web/BasierCircle-Regular.ttf
// module id = 516
// module chunks = 1